import type { MouseEvent } from 'react';

export const createHideOnContextMenuHandler = (
  onHide?: () => void,
): ((event: MouseEvent<HTMLElement>) => void) | undefined => {
  if (!onHide) {
    return undefined;
  }

  return (event) => {
    event.preventDefault();
    event.stopPropagation();
    onHide();
  };
};
